<template>
  <div class="container home" style="overflow: hidden">

    <section class ="hero white hero12">
      <div class="row">
        <div class="col s12 center">
          <h1 class="grey-text text-darken-3"><stron>{{ $t("home.Criptomonete e") }}</stron></h1>
          <h3>{{ $t("home.Criptomonete e2") }} <br> {{ $t("home.Criptomonete e3") }}</h3>
        </div>

      </div>
      
    </section>

    <Service />

    <section class="">
      <div class="row" style="padding-bottom: 0em">
        <div class="col s12">
        <h5 class="blue-grey-text text-darken-4 center">
          {{ $t("home.sevicetitle2") }}<br>
        </h5>
        <ol style="margin-bottom: 36px !important">
          <li>{{ $t("home.servicelists.list1") }}</li>
          <li>{{ $t("home.servicelists.list2") }}</li>
          <li>{{ $t("home.servicelists.list3") }}</li>
          <li>{{ $t("home.servicelists.list4") }}</li>
          <li>{{ $t("home.servicelists.list5") }}</li>
          <li>{{ $t("home.servicelists.list6") }}</li>
          <li>{{ $t("home.servicelists.list7") }}</li>
          <li>{{ $t("home.servicelists.list8") }}</li>
        </ol>
          <div class="col s12 l2 xl2">
            <p class="imagecenter">
              <img src="@/assets/img/romperti-la-testa.jpg" class="responsive-img" alt="{{ $t('home.BenefitBigPaga') }}">
            </p>
          </div>
          <div class="col s12 l10 xl10">
            <h3 class="titlevip">{{ $t("home.titlevip1") }}</h3>
            <h3 class="titlevip">{{ $t("home.titlevip2") }}</h3>
          </div>
          <div class="col s12 center mt-5 btn-register">
            <BuyBTN text="" :isWriting="false"/>
          </div>
          <div class="col s12 center vip">
            <a href="https://www.cryptocurrency10.com/en/tmpr-vip-service/" target="_blank" style="color:#ffffff"><b>{{ $t("MieiNFT.vip") }}</b></a>
          </div>
          </div>
      </div>
    </section>

    <section class="" style="padding-top:0;">

      <div class="row" style="padding-bottom: 0">
        <div v-if="$i18n.locale == 'en'">
          <div class="row" style="padding: 0 !important; margin:0;">
            <div class="col s12 m6" style="margin-bottom: 15px">
              <div class="video-container">
                <iframe width="760" height="415" src="https://www.youtube.com/embed/BDwF5iMpm1Y" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
            <div class="col s12 m6" style="margin-bottom: 15px">
              <div class="video-container">
                <iframe width="760" height="415" src="https://www.youtube.com/embed/sc6R8qbYT0Q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              </div>
            </div>
          </div>
        </div>
        <div class="col s12">
          <h5 class="blue-grey-text text-darken-4 center">
            {{ $t("home.sevicetitle3") }}<br>
          </h5>
          <p class="" v-html="$t('home.servicetext3')"></p>
          <div class="col s12 center mt-5 btn-register">
            <BuyBTN text="" :isWriting="false"/>
          </div>

          <div class="col s12 center vip">
            <a href="https://www.cryptocurrency10.com/en/tmpr-vip-service/" target="_blank" style="color:#ffffff"><b>{{ $t("MieiNFT.vip") }}</b></a>
          </div>
        </div>
      </div>
    </section>

    <section class ="nft" style="padding-top: 0em;">
      <div class="row">
        
        <div class="col s12">
          <h5 class="blue-grey-text text-darken-4 center">
            {{ $t("home.perquenft") }}
          </h5>

          <div class="col s12">
            <div class="col s12 m3 center priceBall">
              <img src="@/assets/img/secure.jpg" class="img-responsive" alt="{{ $t('home.perquenftSicuro') }}">
              <h6 class="center">{{ $t("home.perquenftSicuro") }}</h6>
            </div>
            <div class="col s12 m3 center priceBall">
              <img src="@/assets/img/public.jpg" class="img-responsive" alt="{{ $t('home.perquenftPubblico') }}">
              <h6 class="center">{{ $t("home.perquenftPubblico") }}</h6>
            </div>
            <div class="col s12 m3 center priceBall">
              <img src="@/assets/img/salable.jpg" class="img-responsive" alt="{{ $t('home.perquenftVendibile') }}">
              <h6 class="center">{{ $t("home.perquenftVendibile") }}</h6>
            </div>
            <div class="col s12 m3 center priceBall">
              <img src="@/assets/img/economic.jpg" class="img-responsive" alt="{{ $t('home.perquenftEconomico') }}">
              <h6 class="center">{{ $t("home.perquenftEconomico") }}</h6>
            </div>
          </div>

        </div>

      </div>
    </section>

    <section class ="cost">
      <div class="row">
        <div class="col s12 white-text">
          <h5 class="white-text center">
            {{ $t("home.costititle") }}
          </h5>
          <p class="white-text fixRotationReverse">
            {{ $t("home.costitext") }}
          </p>
          <Table />
          <br><br>
          <p class="white-text fixRotationReverse">
            <span class="yellow-text">*</span> {{ $t("home.costiContattaci") }}
          </p>
          <p class="white-text fixRotationReverse">
            <span class="yellow-text">**</span> {{ $t("home.costitransazione") }}
          </p>
        </div>
      </div>
    </section>

    <section class ="nft">
      <div class="row" style="padding-bottom: 0;">
        <div class="col s12">
          <h5 class="blue-grey-text text-darken-4 center">
            {{ $t("home.ComeRegistrareTitle") }}
          </h5>

            <h5>{{ $t("home.TitlePasso1") }}</h5>

          <span v-html="$t('home.ComeRegistrareText1')"></span>
            <router-link to="/come-installare-metamask" target="_blank"><b>{{ $t('home.ComeRegistrareClick') }}</b></router-link>
          <span v-html="$t('home.ComeRegistrareText2')"></span>

              <h5>{{ $t("home.TitlePasso2") }}</h5>
          <p>{{ $t("home.ComeRegistrareText3") }} (199 <b class="green-text">USDT</b>) {{ $t("home.ComeRegistrareText4") }}<br></p>

          <div v-if="$i18n.locale == 'en'">
            <div class="row" style="padding: 0 !important; margin:0;">
              <div class="col s12 m6">
                <div class="video-container">
                  <iframe width="760" height="415" id="video" src="https://www.youtube.com/embed/99JFQuvM6M4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>

              <div class="col s12 m6">
                <div class="video-container">
                  <iframe width="760" height="415" src="https://www.youtube.com/embed/czb5TfctT_Q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>

            </div>
          </div>
          <div v-else-if="$i18n.locale == 'es'">
            <div class="row" style="padding: 0 !important; margin:0;">
              <div class="col s12 m6" style="margin-bottom: 15px">
                <div class="video-container">
                  <iframe width="760" height="415" src="https://www.youtube.com/embed/Bj0_Kyp45Jc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
              <div class="col s12 m6" style="margin-bottom: 15px">
                <div class="video-container">
                  <iframe width="760" height="415" src="https://www.youtube.com/embed/UitD0afOvsM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="row" style="padding: 0 !important; margin:0;">
              <div class="col s12 m6" style="margin-bottom: 15px">
                <div class="video-container">
                  <iframe width="760" height="415" src="https://www.youtube.com/embed/8hS2BEunE4E" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
              <div class="col s12 m6" style="margin-bottom: 15px">
                <div class="video-container">
                  <iframe width="760" height="415" src="https://www.youtube.com/embed/GzXa9YTPMlo" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
            </div>
          </div>



          <h5>{{ $t("home.TitlePasso3") }}</h5>
           <p> {{ $t("home.ComeRegistrareText5") }} <router-link to="/user" target="_blank"><b>{{ $t("home.ComeRegistrareText6") }}</b></router-link>. <br>
            {{ $t("home.ComeRegistrareText7") }}<br>
          {{ $t("home.ComeRegistrareText51") }}<br>
            {{ $t("home.ComeRegistrareText8") }}<br>
            {{ $t("home.ComeRegistrareText9") }} <b>{{ $t("home.ComeRegistrareText10") }}</b>.<br>
            {{ $t("home.ComeRegistrareText11") }} <b class="green-text">USDT</b>)
            {{ $t("home.ComeRegistrareText12") }}
           </p>


          <div class="col s12 m4 center priceBall">
            <img src="@/assets/img/Register-your-trademark.jpg" class="img-responsive" alt="{{ $t('home.BenefitBigCrea') }}">
            <h6 class="center">{{ $t("home.BenefitBigCrea") }}</h6>
            <p>{{ $t("home.BenefitBigCreaText") }}</p>
          </div>
          <div class="col s12 m4 center priceBall">
            <img src="@/assets/img/Install-MetaMask.jpg" class="img-responsive" alt="{{ $t('home.BenefitBigVendi') }}">
            <h6 class="center">{{ $t("home.BenefitBigVendi") }}</h6>
            <p>{{ $t("home.BenefitBigVendiText") }}</p>
          </div>
          <div class="col s12 m4 center priceBall">
            <img src="@/assets/img/Pay-your-TradeMark-Registration.jpg" class="img-responsive" alt="{{ $t('home.BenefitBigPaga') }}">
            <h6 class="center">{{ $t("home.BenefitBigPaga") }}</h6>
            <p>{{ $t("home.BenefitBigPagaText") }}</p>
          </div>

        </div>
      </div>
    </section>

    <section style="padding-top: 2em;">
      <div class="row" style="padding-bottom: 1em;">
        <div class="col s12 center mt-5">
          <a href="https://www.cryptocurrency10.com/en/tmpr-vip-service/" target="_blank" style="color:#ffffff">
            <img src="@/assets/img/area-VIP-service.jpg" class="responsive-img" alt="{{ $t('home.BenefitBigPaga') }}">
          </a>
        </div>
        <div class="col s12">
          <h5 class="blue-grey-text text-darken-4">{{ $t("home.vipTitle") }}</h5>
          <p>
            <a href="https://www.cryptocurrency10.com/en/tmpr-vip-service/" target="_blank" style="color:#ffffff"><b>{{ $t("home.Request") }}</b></a> {{ $t("home.vipText2") }} <router-link to="/questions" target="_blank"><b>{{ $t("home.DomandeFrequenti") }}</b></router-link>
          </p>
          <div class="col s12 center mt-5 btn-register">
            <BuyBTN text="" :isWriting="false"/>
          </div>
          <div class="col s12 center vip">
            <a href="https://www.cryptocurrency10.com/en/tmpr-vip-service/" target="_blank" style="color:#ffffff"><b>{{ $t("MieiNFT.vip") }}</b></a>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>


<script>
import { ref } from '@vue/reactivity'
import { onMounted } from '@vue/runtime-core';
import BuyBTN from "@/components/Home/BuyBTN"
import Benefit from "@/components/Home/Benefit"
import BenefitBig from "@/components/Home/BenefitBig"
import Table from "@/components/Home/Table"
import Service from "@/components/Home/Service"
import BTN from "@/components/UI/BTN"
import BTNSupport from "@/components/BTNSupport"
import { useRouter } from 'vue-router';
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';

export default {
  components: { BuyBTN, BTN, Benefit, BenefitBig, Table, Service, BTNSupport },
  metaInfo:{
    title: 'message',
    meta: [
      {
        name: 'description',
        contenido: 'Esta es la página de mensajes',
      },
      {
        name: 'keywords',
        content: 'message'
      }
    ]
  },
  setup(){

    const router = useRouter();
    const title = ref('');
    const lines = ref('');
    const isWriting = ref(true);


    let myInterval = null;
    let counter = 0;
    const titleString = "Il Tuo Brand Su NFT";
    
    const write = () => {
      if(counter > 17){
        console.log("Finito");
        isWriting.value = false;
        clearInterval(myInterval);
      }
      title.value += titleString[counter];
      lines.value += "_";
      counter++;
    }

    onMounted(() => {
      console.log(title.value.length, lines.value.length);
      myInterval = setInterval(() => {
        write();
      }, 150);
    })



    return { title, lines, isWriting, router };
  
  }
}
</script>

<style scoped>

.btn-register {
  padding:0 !important;
}

h6{
  font-weight: bold;
}
.container{
  margin:0 !important;
  padding: 0 !important;
  width: 100vw !important;
  max-width: 100% !important;
}

.priceBall{
  padding-top: 10vh;
}

.row{
  padding: 10vw;
  padding-top: 0vh;
  padding-bottom: 10vh;
}

section{
  width: 100vw !important;
  min-height: 23vh !important;
  padding-top: 9vh;
}

.hero12{
  position: relative; 
}

button {
  background-color: #357c38!important;
}

.heroImg{
  border-radius: 50%;
  position: absolute !important;
  right: -120px !important;
  bottom: -190px !important;
  width: 110vh;
  height: 110vh;
  
}

.vip a {
  color: #ffffff;
}

.titlevip {
  font-size: 1.52rem;
  margin: 7px 0px;
}

h1{
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 55px;
  color: #263238;
}

  .nftHero{
      font-size: 60px;
  }

.service{
  
  background-color: #263238;
  transform: skewY(5deg);
}

.service h5, p{
  transform: skewY(-5deg) !important;
}

.cost{
  
  background-color: #000131;
  border: 1px solid black;
  transform: skewY(-5deg);
}

.service {
  background-color: #000131;
  transform: skewY(
      5deg
  );
}

.cost h5, p{
  transform: skewY(5deg) !important;
}

.fixRotation{
  transform: skewY(-5deg) !important;
}

.fixRotationReverse{
  transform: skewY(5deg) !important;
}

.nft .s12, p{
  transform: skewY(0deg) !important;
}

router-link{
  font-weight: bold;
  cursor: pointer;
}

@media screen and (max-width: 670px) {
    h1{
      font-size: 25px;
    }

  h3{
    font-size: 21px;
  }

  .imagecenter {
    text-align: center;
  }

    .nftHero{
      font-size: 35px;
    }

  button {
    width: 100% !important;
  }
}


</style>
